import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const PrivateRoute = () => {
    const isLoggedIn = getUserToken()

    if (!isLoggedIn) {
        return <Navigate to="/" replace />
    }

    return <Outlet />
}

export default PrivateRoute